(function () {
  const observedSections = new WeakMap();

  function bindResponsiveProductMedia(section) {
    if (!section || observedSections.has(section)) return;
    if (!section.querySelector(".product__main")) return;

    const resizeObserver = new ResizeObserver(() => {
      if (typeof window.reinitProductMedia === "function") {
        window.reinitProductMedia(section);
      }
    });

    resizeObserver.observe(section);
    observedSections.set(section, resizeObserver);

    if (typeof window.reinitProductMedia === "function") {
      window.reinitProductMedia(section);
    }
  }

  document.addEventListener("shopify:section:load", function (e) {
    bindResponsiveProductMedia(e.target);
  });

  bindResponsiveProductMedia(document.currentScript?.parentElement);
})();
